import React from 'react';
import { Navigate ,useNavigate} from 'react-router-dom';
import {getcategories} from '../network/api/maincategory'
const RouteRedirect = () => {
  const navigate=useNavigate()
  const [id,setid]=React.useState("")
  React.useEffect(()=>{
    getcategories()
      .then(result=>{
        const firstId = result?.data?.response?.[0]?._id;
        if (firstId) {
          setid(firstId)
          navigate("/c/"+ firstId)
        }
      })
      .catch(()=>{
        // keep spinner; optionally navigate to a safe route
      })
    
  },[])

  if (!id) {
    // You can render a loading indicator or any other component while waiting for the data
    return (<div className='d-flex justify-content-center' >
      <div className="spinner-border text-warning "  role="status">
    <span className="visually-hidden ">Loading...</span>
  </div>
    </div>)
  }


  return <Navigate to={id ? `/c/${id}` : '/'} />;
};

export default RouteRedirect;
